import { ISchema } from 'kosmos/dialogs/CreateResourceModal';
import { IFilterField } from 'models/types';

export const userFilterSchema: IFilterField[] = [
  {
    label: 'Email',
    name: 'email',
    widget: 'text',
  },
  {
    label: 'Role',
    name: 'role',
    widget: 'select',
    options: [
      { label: 'TFP', alias: 'tfp' },
      { label: 'Admin', alias: 'admin' },
      { label: 'Business', alias: 'sme' },
    ]
  },
];

export const userCreateSchema: ISchema = {
  fields: [
    {
      label: 'First Name',
      name: 'firstName',
      required: true,
      widget: 'text',
      description: ''
    },
    {
      label: 'Last Name',
      name: 'lastName',
      required: true,
      widget: 'text',
      description: '',
    },
    {
      label: 'Email',
      name: 'email',
      required: true,
      widget: 'text',
      description: '',
    },
    {
      label: 'Organisation',
      name: 'organisationId',
      required: true,
      widget: 'organisationSelector',
    }
  ]
};
